// extracted by mini-css-extract-plugin
module.exports = {"mx_MessageComposer_collision":"mx_MessageComposer_collision__3EkzDTAfAA0_","visible":"visible__31nQuhTMG5gk"};